import styled, { CSSProperties } from "styled-components";
import { baseLength, getMobileBreakpoint } from "../Styles/globals";

function convertValue(val: string | number | undefined) {
  if (typeof val === "string") return val;
  if (typeof val === "number") return `${val}px`;
  return undefined;
}

const Container = styled.div<
  CSSProperties &
    Partial<{
      onClick: (...args: any) => any;
      imageWidth: number | string;
      imageHeight: number | string;
      mobileFlexDirection: string;
      mobileWidth: number | string;
      mobileHeight: number | string;
      mobileMaxWidth: number | string;
      mobileMaxHeight: number | string;
      mobileMinWidth: number | string;
      mobileMinHeight: number | string;
      mobileMargin: any;
      mobileMarginTop: number | string;
      mobileMarginLeft: number | string;
      mobileMarginRight: number | string;
      mobileMarginBottom: number | string;
      mobilePadding: number | string;
      mobilePaddingTop: number | string;
      mobilePaddingRight: number | string;
      mobilePaddingBottom: number | string;
      mobilePaddingLeft: number | string;
      mobileTransition: any;
      mobileBoxShadow: any;
      mobileImageWidth: number | string;
      mobileImageHeight: number | string;
    }>
>`
  width: ${(props) => convertValue(props.width)};
  height: ${(props) => convertValue(props.height)};
  max-width: ${(props) => convertValue(props.maxWidth)};
  max-height: ${(props) => convertValue(props.maxHeight)};
  min-width: ${(props) => convertValue(props.minWidth)};
  min-height: ${(props) => convertValue(props.minHeight)};
  background-color: ${(props) => props.backgroundColor};
  opacity: ${(props) => props.opacity};
  cursor: ${(props) => props.cursor};
  text-align: ${(props) => props.textAlign};
  word-break: ${(props) => props.wordBreak};
  white-space: ${(props) => props.whiteSpace};
  overflow: ${(props) => props.overflow};
  overflow-x: ${(props) => props.overflowX};
  overflow-y: ${(props) => props.overflowY};
  text-overflow: ${(props) => props.textOverflow};
  visibility: ${(props) => props.visibility};
  display: ${(props) => props.display};
  outline: ${(props) => props.outline};

  p {
    color: ${(props) => props.color};
  }

  border: ${(props) => props.border};
  border-top: ${(props) => props.borderTop};
  border-right: ${(props) => props.borderRight};
  border-bottom: ${(props) => props.borderBottom};
  border-left: ${(props) => props.borderLeft};
  border-radius: ${(props) => props.borderRadius}px;
  border-top-left-radius: ${(props) => props.borderTopLeftRadius};
  border-top-right-radius: ${(props) => props.borderTopRightRadius};
  border-bottom-left-radius: ${(props) => props.borderBottomLeftRadius};
  border-bottom-right-radius: ${(props) => props.borderBottomRightRadius};

  margin: ${(props) => props.margin};
  margin-top: ${(props) => convertValue(props.marginTop)};
  margin-left: ${(props) => convertValue(props.marginLeft)};
  margin-right: ${(props) => convertValue(props.marginRight)};
  margin-bottom: ${(props) => convertValue(props.marginBottom)};

  padding: ${(props) => convertValue(props.padding)};
  padding-top: ${(props) => convertValue(props.paddingTop)};
  padding-right: ${(props) => convertValue(props.paddingRight)};
  padding-bottom: ${(props) => convertValue(props.paddingBottom)};
  padding-left: ${(props) => convertValue(props.paddingLeft)};

  transition: ${(props) => props.transition};
  box-shadow: ${(props) => props.boxShadow};

  z-index: ${(props) => props.zIndex};
  position: ${(props) => props.position};

  svg {
    width: ${(props) => convertValue(props.imageWidth)};
    height: ${(props) => convertValue(props.imageHeight)};
  }

  @media (max-width: ${getMobileBreakpoint}) {
    width: ${(props) => convertValue(props.mobileWidth)};
    height: ${(props) => convertValue(props.mobileHeight)};
    max-width: ${(props) => convertValue(props.mobileMaxWidth)};
    max-height: ${(props) => convertValue(props.mobileMaxHeight)};
    min-width: ${(props) => convertValue(props.mobileMinWidth)};
    min-height: ${(props) => convertValue(props.mobileMinHeight)};

    margin: ${(props) => convertValue(props.mobileMargin)};
    margin-top: ${(props) => convertValue(props.mobileMarginTop)};
    margin-left: ${(props) => convertValue(props.mobileMarginLeft)};
    margin-right: ${(props) => convertValue(props.mobileMarginRight)};
    margin-bottom: ${(props) => convertValue(props.mobileMarginBottom)};

    padding: ${(props) => convertValue(props.mobilePadding)};
    padding-top: ${(props) => convertValue(props.mobilePaddingTop)};
    padding-right: ${(props) => convertValue(props.mobilePaddingRight)};
    padding-bottom: ${(props) => convertValue(props.mobilePaddingBottom)};
    padding-left: ${(props) => convertValue(props.mobilePaddingLeft)};

    transition: ${(props) => props.mobileTransition};
    box-shadow: ${(props) => props.mobileBoxShadow};

    svg {
      width: ${(props) => convertValue(props.mobileImageWidth)};
      height: ${(props) => convertValue(props.mobileImageHeight)};
    }
  }
`;

const FlexContainer = styled(Container)`
  display: flex;
  flex-direction: ${(props) => props.flexDirection};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
  flex-wrap: ${(props) => props.flexWrap};
  @media (max-width: ${getMobileBreakpoint}) {
    flex-direction: ${(props) => props.mobileFlexDirection || props.flexDirection};
  }
`;

const Spacing = styled.div<
  CSSProperties &
    Partial<{
      row: any;
      space: any;
      mobileSpace: number;
      laptopSpace: number;
    }>
>`
  width: 0px;
  height: 0px;
  padding: 0px;
  margin: 0px ${(props) => (props.row ? props.space : "0")}px ${(props) => props.space}px 0px;

  @media (max-width: ${getMobileBreakpoint}) {
    margin: 0px ${(props) => (props.row ? props.mobileSpace : "0")}px ${(props) => props.mobileSpace}px 0px;
  }

  @media (min-width: 768px) {
    margin: 0px ${(props) => (props.row ? props.laptopSpace : "0")}px ${(props) => props.laptopSpace}px 0px;
  }
`;

const ScrollContainer = styled(Container)<CSSProperties>`
  padding-right: ${2 * baseLength}px;
  overflow-x: hidden;
  overflow-y: auto;
  /* width */
  ::-webkit-scrollbar {
    width: ${baseLength}px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: ${2.5 * baseLength}px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #babcc2;
    border-radius: ${2.5 * baseLength}px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #9fa1a7;
  }
`;

export { Container, FlexContainer, Spacing, ScrollContainer };
